// extracted by mini-css-extract-plugin
export var label = "_hw-2";
export var slideContainer = "_hw-0";
export var slider = "_hw-1";